import axios from 'axios';

const baseURL = window.location.hostname === 'localhost'
  ? 'http://localhost:4004'
  : '/api';

const api = axios.create({
  baseURL,
});

function tokenExpirado(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return Date.now() >= payload.exp * 1000;
  } catch {
    return true;
  }
}

function irALogin() {
  localStorage.removeItem('token');
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
}

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      if (tokenExpirado(token)) {
        irALogin();
        return Promise.reject(new Error('Token expirado'));
      }
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      irALogin();
    }
    return Promise.reject(error);
  }
);

export default api;